import { POKEDEX } from '~/data/pokedex'
import POKEMON_FORMS_RAW from '../../../shared/pokemon-forms.json'

/** Slug Pokédex principal → FR/EN (recherche O(1)). */
const MAIN_NAMES_BY_SLUG = new Map<string, { nameFr: string; nameEn: string }>()
for (const e of POKEDEX) {
  MAIN_NAMES_BY_SLUG.set(e.slug, { nameFr: e.nameFr, nameEn: e.nameEn })
}

type FormRow = { slug: string; nameFr: string; nameEn: string }

let FORM_NAMES_BY_SLUG: Map<string, { nameFr: string; nameEn: string }> | null = null

function formNamesIndex(): Map<string, { nameFr: string; nameEn: string }> {
  if (FORM_NAMES_BY_SLUG) return FORM_NAMES_BY_SLUG
  const m = new Map<string, { nameFr: string; nameEn: string }>()
  const raw = POKEMON_FORMS_RAW as { formsByBaseSlug?: Record<string, FormRow[]> }
  for (const rows of Object.values(raw.formsByBaseSlug ?? {})) {
    if (!Array.isArray(rows)) continue
    for (const row of rows) {
      if (row?.slug && row.nameFr && row.nameEn) {
        m.set(row.slug, { nameFr: row.nameFr, nameEn: row.nameEn })
      }
    }
  }
  FORM_NAMES_BY_SLUG = m
  return m
}

/** Noms officiels FR/EN pour un slug espèce ou forme (Méga, etc.). */
export function resolveCanonicalSpeciesNames(
  slug: string | null | undefined,
): { nameFr: string; nameEn: string } | null {
  if (!slug || typeof slug !== 'string') return null
  const fromMain = MAIN_NAMES_BY_SLUG.get(slug)
  if (fromMain) return { ...fromMain }
  const fromForm = formNamesIndex().get(slug)
  if (fromForm) return { ...fromForm }
  return null
}

/** Libellé localisé : priorité au Pokédex client (corrige données API/BDD médiocres). */
export function localizedPokemonSpeciesLabel(
  slug: string | null | undefined,
  apiNameFr: string | null | undefined,
  apiNameEn: string | null | undefined,
  t: (fr: string, en: string) => string,
): string {
  const canon = resolveCanonicalSpeciesNames(slug)
  if (canon) return t(canon.nameFr, canon.nameEn)
  const fr = (apiNameFr && String(apiNameFr).trim()) || slug || '???'
  const en = (apiNameEn && String(apiNameEn).trim()) || slug || '???'
  return t(fr, en)
}
